var map = {
	"./music-instructions.json": 4645,
	"./music-library-intro2024.json": 4646,
	"./music-library-launch2024.json": 4647,
	"./music-progression.json": 4648,
	"./startSourcesAdvanced.json": 4649,
	"./startSourcesSimple.json": 4650,
	"./startSourcesSimple2.json": 4651,
	"./startSourcesTracks.json": 4652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4423;